import Vue from 'vue';
import Router from 'vue-router';
import Home from 'main/view/main/Main';
import Login from 'main/view/login/Login';
import {Message} from 'element-ui';
import {isAuth} from '../utils/auth';

Vue.use(Router);

let router = new Router({
	routes: [
		{
			path: '/',
			name: '',
			meta: {sign: 'IS_NOT_REQUIRE'},
			redirect: '/login'
		},
		{
			path: '/login',
			name: 'login',
			meta: {sign: 'IS_NOT_REQUIRE'},
			title: '登录',
			component: Login
		},
		{
			path: '/icmp',
			name: 'icmp',
			title: '首页',
			meta: {sign: 'AUTH_INDEX'},
			component: Home,
			children: [
				// 首页
				{
					path: '',
					title: '小程序管理',
					name: 'map-index',
					meta: {sign: 'AUTH_INDEX'},
					icon: 'arrow-move',
					component: () => import('main/view/project/list')
				},
				{
					path: 'project-detail',
					title: '小程序项目详情',
					name: 'project-detail',
					meta: {sign: 'AUTH_DETAIL'},
					component: () => import('main/view/project/detail')
				},
				// 公众号管理
				{
					path: 'official-account-manage',
					title: '公众号管理',
					name: 'official-account-manage',
					meta: {sign: 'OFFICIAL_ACCOUNT_MANAGE'},
					icon: 'arrow-move',
					component: () => import('main/view/official-account/list')
				},
				{
					path: 'official-account-detail',
					title: '公众号项目详情',
					name: 'official-account-detail',
					meta: {sign: 'OFFICIAL_ACCOUNT__DETAIL'},
					component: () => import('main/view/official-account/detail')
				},
				// 公众号管理
				{
					path: 'open-platform-manage',
					title: '开放平台管理',
					name: 'open-platform-manage',
					meta: {sign: 'OPEN_PLATFORM_MANAGE'},
					icon: 'arrow-move',
					component: () => import('main/view/open-platform-manage/index')
				},
				{
					path: 'customer-manage',
					title: '客户管理',
					name: 'customer-manage',
					meta: {sign: 'CUSTOMER_MANAGE'},
					component: () => import('main/view/customer-manage/index')
				}
			]
		}
	]
});

router.beforeEach((to, from, next) => {
	if (to.matched.length > 0 && to.matched[1] && (to.matched[1].name === 'map-index' || to.matched[1].name === 'grid-manage-edit')) {
		// 所有map页面html类名样式
		document.getElementsByTagName('html')[0].className = 'map-html';
	} else {
		document.getElementsByTagName('html')[0].className = (to.path.split('/')[2] || to.path.split('/')[1]) + '-page';
	}
	if (true) {
		next();
	} else {
		if (!isAuth(to.meta.sign)) {
			if (to.meta.sign == 'AUTH_INDEX') {
				next({
					path: '/icmp/personal-center'
				});
			} else {
				Message({
					message: '对不起，您没有权限！',
					type: 'error'
				});
				next({
					path: '/login'
				});
			}
		} else {
			next();
		}
	}
});
export default router;



// WEBPACK FOOTER //
// ./main/router/index.js